import React from "react";
import LayoutDay from "../../../components/Chronology/LayoutDay";
import ContentLeft from "../../../components/Chronology/Modules/ContentLeft";
import ContentRight from "../../../components/Chronology/Modules/ContentRight";
import ModCCAATable from "../../../components/Chronology/Modules/ModCCAATable";
import ModTwoCols from "../../../components/Chronology/Modules/ModTwoCols";
import ModTwoImgCols from "../../../components/Chronology/Modules/ModTwoImgCols";
import ModText from "../../../components/Chronology/Modules/ModText";
import InlineLink from "../../../components/Chronology/Modules/InlineLink";
import ModImage from "../../../components/Chronology/Modules/ModImage";
import ModReferenceList from "../../../components/Chronology/Modules/ModReferenceList";
import ModAnimation from "../../../components/Chronology/Modules/ModAnimation";
import ReferenceRow from "../../../components/Chronology/Modules/ReferenceRow";
import ModDatafactLegacy from "../../../components/Chronology/Modules/ModDatafactLegacy";
import ModDatafactCountry from "../../../components/Chronology/Modules/ModDatafactCountry";
import ModDatafactCCAA from "../../../components/Chronology/Modules/ModDatafactCCAA";
import ModCovidHighlight from "../../../components/Chronology/Modules/ModCovidHighlight";
import ModBuscandoDatos from "../../../components/Chronology/Modules/ModBuscandoDatos";
import ModDashedLine from "../../../components/Chronology/Modules/ModDashedLine";
import ModReport from "../../../components/Chronology/Modules/ModReport";
import ModDailyHighlight from "../../../components/Chronology/Modules/ModDailyHighlight";
import ModDataEuLegacy from "../../../components/Chronology/Modules/ModDataEuLegacy";
import ModDataEu from "../../../components/Chronology/Modules/ModDataEu";
import ModLethalityEu from "../../../components/Chronology/Modules/ModLethalityEu";
import ModLethalityEuLegacy from "../../../components/Chronology/Modules/ModLethalityEuLegacy";
import ModDottedLine from "../../../components/Chronology/Modules/ModDottedLine";
import ModGraph from "../../../components/Chronology/Modules/ModGraph";
import { StrongWhite, StrongGold } from "../../../components/Textstyles/Styles";
import ModVideo from "../../../components/Chronology/Modules/ModVideo";
import ModDataEs from "../../../components/Chronology/Modules/ModDataEs";

export const frontmatter = {
  title: "Día 63",
  week: "Semana 9",
  day: "15",
  month: "may",
  monthNumber: "05",
  date: "2020-05-15",
  path: "/cronologia/semana-10#dia-15-may/",
};
const Day63 = (props) => {
  return (
    <LayoutDay frontmatter={frontmatter} {...props}>
      <ContentLeft>
        <ModCCAATable fecha={frontmatter.date} />
        <ModDottedLine />
        <ModText>
          <strong>Mayor crecimiento diario</strong>
        </ModText>
        <ModDatafactCCAA
          fecha={frontmatter.date}
          ccaa="es-ct"
          data="casosConfirmadosDiario"
        />
        <ModDashedLine />

        <ModDataEu fecha={frontmatter.date} />
        <ModLethalityEu fecha={frontmatter.date} numPaises={8} />

        <ModBuscandoDatos num="10" />
      </ContentLeft>

      <ContentRight>
        <ModText>
          En <strong>España</strong>, el balance del día se salda con el
          registro de 1.627 nuevos positivos y 138 personas fallecidas.
          Permanecen hospitalizadas 124.571 personas, 346 más que el día
          anterior, y 1.409 reciben el alta. El número de casos ingresados en la
          UCI asciende a 11.493, lo que supone un aumento de 29 personas.
        </ModText>
        <ModText>
          Respecto al número de casos totales confirmados, la tasa de letalidad
          es del 10,0 % y la tasa de recuperados del 52,8 %.
        </ModText>
        <ModGraph
          src="/graphs/15-05-es-fallecidos-semanal.png"
          alt="casos fallecidos por semana en España con Covid-19"
        />
        <ModGraph
          src="/graphs/15-05-es-recuperados-semanal.png"
          alt="casos recuperados por semana en España con Covid-19"
        />
        <ModText>
          El número de casos activos, condiderado como el número de casos
          confirmados - (recuperados-fallecidos), disminuye en términos
          absolutos por tercera semana consecutiva. Esta contracción en el
          número de contagiosos es una buena noticia, por el impacto positivo en
          la velocidad a la que se frena la expansión de la pandemia.
        </ModText>

        <ModGraph
          src="/graphs/15-05-es-activos-semanal.png"
          alt="casos activos por semana en España con Covid-19"
        />
      </ContentRight>
    </LayoutDay>
  );
};
export default Day63;
